const routes = [
  {
    path: '/m/home',
    name: 'm-home',
    component: () => import('@/views/home/mIndex.vue'),
    meta: {
      title: 'WPS 365教育版- 一体化数字教育体验，专为教育打造的数字化解决方案-安全高效-协同教学办公-WPS 365教育版官网'
    }
  },
  {
    path: '/m/help',
    name: 'm-help',
    component: () => import('@/views/help/mIndex.vue'),
    meta: {
      title: 'WPS 365教育版- 一体化数字教育体验，专为教育打造的数字化解决方案-安全高效-协同教学办公-WPS 365教育版官网'
    }
  },
  {
    path: '/m/helplist',
    name: 'm-helplist',
    component: () => import('@/views/help/HelpList.vue'),
    meta: {
      title: 'WPS 365教育版- 一体化数字教育体验，专为教育打造的数字化解决方案-安全高效-协同教学办公-WPS 365教育版官网'
    }
  },
  {
    path: '/m/price',
    name: 'price',
    component: () => import('@/views/price/src/Index.vue'),
    meta: {
      title: 'WPS 365教育版-WPS 365教育版官网-正版WPS- 在线文档-WPS云盘'
    }
  },
];

export default routes;
